export default __webpack_public_path__ + "static/media/background-logo.0dade824.png";